import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function payChannelConfigList(data) { return axios.post(`${base.url}/payment/payChannelConfig/list`, qs.stringify(data)) }
export function payChannelConfigDetail(id) { return axios.post(`${base.url}/payment/payChannelConfig/detail`, qs.stringify({ id })) }
export function payChannelConfigAddOrUpdate(data) { return axios.post(`${base.url}/payment/payChannelConfig/addOrUpdate`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } }) }
export function payChannelConfigDelete(id) { return axios.post(`${base.url}/payment/payChannelConfig/deleteBatchIds`, qs.stringify({ ids: id })) }
export function payChannelConfigStatus(id, status) { return axios.post(`${base.url}/payment/payChannelConfig/status`, qs.stringify({ id, status })) }
